export default __webpack_public_path__ + "static/media/leavemgmt-illustration.89a66c45.svg";